export default {
    "html": require('./html').default
}